module.exports = __webpack_public_path__ + "img/mastercard-idcheck.8f6ba038.png";